import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { lazy, Suspense } from "react";
import { API_MODE } from "@/api/client";
import { ToastProvider } from "@/ui/toast";
import { queryClient, router } from "./router";

/** Dev navigator: `vite dev` + mock API only, lazily loaded so it never ships in a build. */
const DevNavigator = import.meta.env.DEV && API_MODE === "mock" ? lazy(() => import("@/dev/navigator")) : null;

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <RouterProvider router={router} />
        {DevNavigator && (
          <Suspense fallback={null}>
            <DevNavigator />
          </Suspense>
        )}
      </ToastProvider>
    </QueryClientProvider>
  );
}
